export default __webpack_public_path__ + "static/media/ritual-make3.c2dbb351.png";